import { Box } from '@mui/material';
import React from 'react';
import type { HowItWorksStep } from '../../types/howItWorks';
import StepBubble from './StepBubble';

export interface HowItWorksTimelineProps {
  steps: HowItWorksStep[];
  selectedStepId: string | null;
  onSelectStep: (id: string) => void;
}

const HowItWorksTimeline: React.FC<HowItWorksTimelineProps> = ({ steps, selectedStepId, onSelectStep }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
      {/* Vertical process line running down the left; each step has a row with connector + bubble */}
      <Box sx={{ borderLeft: '2px solid', borderColor: 'divider', pl: 2 }}>
        {steps.map((step) => (
          <Box
            key={step.id}
            sx={{
              position: 'relative',
              mb: 1.5,
              '&::before': {
                content: '""',
                position: 'absolute',
                left: -14,
                top: 20,
                width: 14,
                borderTop: '1px solid',
                borderColor: 'divider',
              },
            }}
          >
            <StepBubble
              step={step}
              selected={selectedStepId === step.id}
              onClick={() => onSelectStep(step.id)}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default HowItWorksTimeline;
